import api from './axios';

export const sendOtp = async (phone) => {
    return api.post('/auth/send-otp', { phone });
}
export const verifyOtp = async (otp, session_token) => {
    return api.post('/auth/verify-otp', {  otp, session_token });
}
export const logoutUser = async () => {
    return api.post('/auth/logout');
}